import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TPpwrApi } from './types';

export const ppwr: TPpwrApi = {
	searchPackagingTypes: (payload) =>
		http.post(endpoint.ppwr.SEARCH_PACKAGING_TYPES, payload).then((response) => response.data),
	getPackagingType: (payload) =>
		http.get(endpoint.ppwr.PACKAGING_TYPE_DETAILS(payload.id)).then((response) => response.data),
	createPackagingType: (payload) =>
		http.post(endpoint.ppwr.CREATE_PACKAGING_TYPE, payload).then((response) => response.data),
	updatePackagingType: (payload) =>
		http
			.put(endpoint.ppwr.UPDATE_PACKAGING_TYPE(payload.id), payload.body)
			.then((response) => response.data),
	updatePackagingTypeHandler: (payload) =>
		http
			.put(endpoint.ppwr.UPDATE_PACKAGING_TYPE_HANDLER(payload.id), payload.body)
			.then((response) => response.data),
	searchFees: (payload) =>
		http.post(endpoint.ppwr.SEARCH_FEES, payload).then((response) => response.data),
	getFee: (payload) =>
		http.get(endpoint.ppwr.FEE_DETAILS(payload.id)).then((response) => response.data),
	createFee: (payload) =>
		http.post(endpoint.ppwr.CREATE_FEE, payload).then((response) => response.data),
	updateFee: (payload) =>
		http.put(endpoint.ppwr.UPDATE_FEE(payload.id), payload.body).then((response) => response.data),
	searchEmSettings: (payload) =>
		http.post(endpoint.ppwr.SEARCH_EM_SETTINGS, payload).then((response) => response.data),
	getEmSettings: (payload) =>
		http.get(endpoint.ppwr.EM_SETTINGS_DETAILS(payload.emId)).then((response) => response.data),
	updateEmSettings: (payload) =>
		http
			.put(endpoint.ppwr.UPDATE_EM_SETTINGS(payload.emId), payload.body)
			.then((response) => response.data),
	searchJotforms: (payload) =>
		http.post(endpoint.ppwr.SEARCH_JOTFORMS, payload).then((response) => response.data),
	getJotform: (payload) =>
		http.get(endpoint.ppwr.JOTFORM_DETAILS(payload.jotformId)).then((response) => response.data),
	/** Resolves with the whole response: status 210 carries a duplicate warning. */
	activateService: (payload) =>
		http.post(endpoint.ppwr.ACTIVATE_SERVICE(payload.jotformId), payload.body),
	searchEmPackagingTypes: (payload) =>
		http
			.post(endpoint.ppwr.SEARCH_EM_PACKAGING_TYPES(payload.emId), payload.body)
			.then((response) => response.data),
	updateEmPackagingType: (payload) =>
		http
			.put(endpoint.ppwr.UPDATE_EM_PACKAGING_TYPE(payload.emId, payload.pckgTypeId), payload.body)
			.then((response) => response.data),
	uploadEmPackagingTypeDocument: (payload) => {
		const formData = new FormData();
		formData.append('File', payload.file);
		return http
			.post(
				endpoint.ppwr.UPLOAD_EM_PACKAGING_TYPE_DOCUMENT(payload.emId, payload.pckgTypeId),
				formData,
			)
			.then((response) => response.data);
	},
	downloadEmPackagingTypeDocument: (payload) =>
		http
			.get(endpoint.ppwr.DOWNLOAD_EM_PACKAGING_TYPE_DOCUMENT(payload.emId, payload.documentId), {
				responseType: 'blob',
			})
			.then((response) => response.data),
	deleteEmPackagingTypeDocument: (payload) =>
		http
			.delete(endpoint.ppwr.DELETE_EM_PACKAGING_TYPE_DOCUMENT(payload.emId, payload.documentId))
			.then((response) => response.data),
	searchEmCountryExclusions: (payload) =>
		http
			.post(endpoint.ppwr.SEARCH_EM_COUNTRY_EXCLUSIONS, payload)
			.then((response) => response.data),
	createEmCountryExclusion: (payload) =>
		http.post(endpoint.ppwr.CREATE_EM_COUNTRY_EXCLUSION, payload).then((response) => response.data),
	updateEmCountryExclusion: (payload) =>
		http
			.put(endpoint.ppwr.UPDATE_EM_COUNTRY_EXCLUSION(payload.id), payload.body)
			.then((response) => response.data),
};
